import React, { useState } from 'react';
import {
    Box,
    Stepper,
    Step,
    StepLabel,
    Button,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    useTheme,
    useMediaQuery
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DetailTemplate from '../common/template/DetailTemplate';
import PartnerFormContainer from '../../containers/partnermng/PartnerFormContainer';
import PartnerAddGuideInfo from './PartnerAddGuideInfo';

const steps = [
    { value: 0, label: '기본정보', color: 'info' },
    { value: 1, label: '파일관리', color: 'primary' },
];

const PartnerStepperTemplate = ({ handleClose, isModal }) => {
    const [activeStep, setActiveStep] = useState(0);
    const [message, setMessage] = useState(
        '기본사항 등록이 완료되지 못했습니다.',
    );

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleNext = () => {

    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    return (
        <Box>
            <Box sx={{ my: 1 }}>
                {isMobile ? (
                    <Accordion 
                        variant="outlined" 
                        sx={{ 
                            backgroundColor: '#fafafa', 
                            borderColor: '#e0e0e0',
                            borderRadius: '4px !important',
                            minHeight: 0,
                            '&:before': { display: 'none' } 
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon sx={{ fontSize: '1.25rem' }} />}
                            sx={{ 
                                minHeight: '32px !important',
                                height: 32,
                                px: 1.5,
                                '& .MuiAccordionSummary-content': { 
                                    my: '0 !important',
                                    alignItems: 'center'
                                } 
                            }}
                        >
                            <Typography sx={{ fontSize: '0.815rem', fontWeight: 'bold', color: 'text.secondary' }}>
                                거래처 가이드 (클릭 시 펼침)
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ p: 1, pt: 0.5, pb: 0.5 }}>
                            <PartnerAddGuideInfo />
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <PartnerAddGuideInfo />
                )}
            </Box>

            <Box sx={{ width: '100%' }}>
                <Stepper sx={{
                    pt: 2,
                    pb: 1,
                    backgroundColor: '#eeeeee',
                }}
                    activeStep={activeStep}
                    alternativeLabel>
                    {steps.map((step) => {
                        const stepProps = {};
                        const labelProps = {};

                        if (activeStep === steps.length - 1) {
                            stepProps.completed = true;
                        }
                        return (
                            <Step key={step.label} {...stepProps}>
                                <StepLabel
                                    {...labelProps}
                                >{step.label}</StepLabel>
                            </Step>
                        )
                    })}
                </Stepper>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                    }}
                >
                    {activeStep === 0 && (
                        <DetailTemplate title="기본정보">
                            <PartnerFormContainer 
                                type="add"
                                handleClose={handleClose}
                                isModal={isModal}
                            />
                        </DetailTemplate>
                    )}
                    {activeStep === 1 && (
                        <DetailTemplate title="파일관리">
                            <Typography variant="body2">기본정보를 저장해야합니다.</Typography>
                        </DetailTemplate>
                    )}
                </Box>
            </Box>
        </Box>
    )
}

export default PartnerStepperTemplate;
